export const environment = {
  production: true,
  baseUrl: 'https://atosnormativos.sistemaindustria.com.br/api-atosnormativo',
  baseUrlSso: 'https://app.sistemaindustria.com.br/PortaldeAutenticacao/LoginSSOMicrosoft?clientID=c2lzdGF0b3Nub3JtYXRpdm8yNTA2MT&tecnologia=angular',
  baseCorporativoUrl: 'https://atosnormativos.sistemaindustria.com.br/api-atosnormativo',
  proxyPrefix: 'api',
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts